module.exports = __webpack_public_path__ + "media/scanner/scan-yellow-2eb36944.png";